import React, { Component, Fragment } from 'react';
import 'styles/samplemenu.css';
import macrosic from 'assets/protein.svg';
import kcalic from 'assets/calories.svg';
import fatIcon from 'assets/fat.svg';
import proteinIcon from 'assets/protein.svg';
import Dish from '../../Checkout/Dish';
import noImage from 'assets/no_img.svg';

class SampleMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openSection: null,
      activeDay: 0
    };
  }

  toggleSection = (section) => {
    this.setState({
      openSection:
        this.state.openSection === section ? null : section
    });
  };

  
  handleDayChange = (day) => {
  this.setState({
    activeDay: day
  });
};

renderMenuCard = (type_id,item) => {
  const {typeList,productsList,setModal } = this.props.dataArray || {};
  const product = productsList[item] || {};
  console.debug(product);
  //  return <Dish dataArray={this.props.dataArray} setModal={setModal} product={product} typeList={typeList} type_id={type_id}  />;
  
  // return item;
  let name =product.title || 'Empty';
   const imgUrl = product.image ? `${product.image}` : noImage;
  
  return (
    <article
      className="menucard"
      key={name}
      tabIndex="0"
      aria-label={name}
    >
      <img
        src={imgUrl}
        width="240"
        height="240"
        alt={name}
      />
      <div className="article_details">
        <span className="plan_type">
          {typeList[type_id].title}
        </span>

        <p>{name}</p>
      </div>
    </article>
  );
};

renderSampleMenu = (menus) => {
  console.debug('menus');
  console.debug(menus);
  let activeItems = menus[this.state.activeDay] || {};
   console.debug(activeItems);
  return (
    <section className="sample-menu-section">
      <div className="sample_menu_container">
        <h3>Sample Menu</h3>
      </div>

      <nav
        className="tabs"
        role="tablist"
        aria-label="Sample Menu Days"
      >
        {['day1', 'day2', 'day3'].map((day, index) => {
          let dayNumber = index + 1;
          let isActive = this.state.activeDay === index;
          return (
            <button
              key={day}
              type="button"
              className={
                'tab ' + (isActive ? 'active' : '')
              }
              role="tab"
              aria-selected={isActive}
              aria-controls={day}
              onClick={() => this.handleDayChange(index)}
            >
              Day {dayNumber}
            </button>
          );
        })}
      </nav>

      <div className="sample-menu-content">
        <div
          id={this.state.activeDay}
          role="tabpanel"
          aria-live="polite"
        >
          <div className="dayscollection">
            {Object.keys(activeItems).length>0 && Object.keys(activeItems).map((index)=>{ return this.renderMenuCard(index,activeItems[index]);})}
          </div>
        </div>
      </div>
    </section>
  );
};
  renderMacroRow = (label, value, iconClass) => {
    return (
      <div className="macro_details">
        <div className={'macro-icon ' + iconClass}>
          {iconClass === 'kcal-icon' &&<img src={kcalic} alt="Calories" /> }
          {iconClass === 'protein-icon' && <img src={proteinIcon} alt="protein" />}
          {iconClass === 'carb-icon' && <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_93_481)"><path d="M24.9651 1.87752L25.5041 2.01039L25.365 2.52524C24.6014 5.35142 21.5792 7.05396 18.6204 6.32464L18.0814 6.19178L18.2205 5.67692C18.9841 2.85074 22.0063 1.1482 24.9651 1.87752Z" stroke="#9C835B" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22.1453 10.0407L22.4281 10.4987L21.9486 10.7688C19.3166 12.2515 15.9192 11.414 14.367 8.89993L14.0842 8.44192L14.5637 8.17181C17.1957 6.68911 20.5931 7.52656 22.1453 10.0407Z" stroke="#9C835B" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.0859 8.4436L13.8032 7.9856C12.2509 5.47148 13.1277 2.22627 15.7597 0.743565L16.2392 0.473454L16.5219 0.931462C18.0742 3.44558 17.1975 6.69079 14.5654 8.17349L14.0859 8.4436Z" stroke="#9C835B" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.7996 13.0531L17.0824 13.5111L16.6029 13.7813C13.9709 15.264 10.5735 14.4265 9.02125 11.9124L8.73847 11.4544L9.21796 11.1843C11.85 9.70156 15.2474 10.539 16.7996 13.0531Z" stroke="#9C835B" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.73999 11.4545L8.45721 10.9965C6.90497 8.48234 7.7817 5.23713 10.4137 3.75443L10.8932 3.48432L11.176 3.94233C12.7282 6.45644 11.8515 9.70166 9.21948 11.1844L8.73999 11.4545Z" stroke="#9C835B" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.4517 16.0651L11.7345 16.5231L11.255 16.7932C8.623 18.2759 5.22559 17.4385 3.67335 14.9243L3.39057 14.4663L3.87006 14.1962C6.50209 12.7135 9.8995 13.551 11.4517 16.0651Z" stroke="#9C835B" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.39307 14.468L3.11029 14.01C1.55805 11.4959 2.43478 8.25068 5.06681 6.76798L5.5463 6.49787L5.82908 6.95588C7.38132 9.46999 6.50458 12.7152 3.87255 14.1979L3.39307 14.468Z" stroke="#9C835B" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.0856 6.18921L14.1261 8.42045L13.6472 8.6906L8.36045 11.668L7.88161 11.9381L0.495361 16.099" stroke="#9C835B" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_93_481"><rect width="26" height="18" fill="white"></rect></clipPath></defs></svg>}
          {iconClass === 'fat-icon' && <img src={fatIcon} alt="fat" />}
        </div>

        <div className="macro-label">
          <span>{label}</span>
          <strong>{value}</strong>
        </div>
      </div>
    );
  };

  renderInfoSection = (title, items) => {
    const renderData= (datas) =>Array.isArray(datas) && <ul>
              {datas.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>;
    console.debug(items);
    console.debug(typeof items === 'object');
    return (
      <div className="info-box">
         <div class="flex_header"><h3>{title}</h3></div>
          <div className="whatIsdesc">
           {renderData(items)}
            {typeof items === 'object' && !Array.isArray(items) && Object.keys(items).map((key)=>{
                 return <Fragment>
                  <h2>{key}</h2>
                  {renderData(items[key])}
                 </Fragment>
            })
            }
          </div>
       
      </div>
    );
  };
  renderRange = (key,macro,combine) => {
    let sum={'min':0,'max':0}
    
    combine.length>0 && combine.map((value)=>{
        sum.min+=macro[value][key].min;
        sum.max+=macro[value][key].max;
    })
    
    if (sum.min === sum.max) {
      return String(sum.min);
    }
    return sum.min + ' to ' + sum.max;
  };
  renderMacroCard = (title, data, combine) => {
    var className = 'macro-card';


    return (
      <article className={className}>
        <div className="grid_header">
          <h4>{title}</h4>
          <div className="svgdiv"><svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32.6906 34.1249H27.167L29.9288 31.3635L32.6906 34.1249Z" fill="white"></path>
<path d="M33.1457 11.728V33.6705L30.251 30.7756V8.8335L33.1457 11.728Z" fill="white"></path>
<path d="M29.6078 8.8335V30.7758L26.7129 33.6705V11.728L29.6078 8.8335Z" fill="white"></path>
<path d="M29.6082 4.875H9.39258V7.73621H29.6082V4.875Z" fill="white"></path>
<path d="M29.1529 8.37891L26.258 11.2736H6.30859L9.2037 8.37891H29.1529Z" fill="white"></path>
<path d="M18.7884 20.3722C19.5441 20.3722 20.1568 19.5706 20.1568 18.5818C20.1568 17.593 19.5441 16.7914 18.7884 16.7914C18.0326 16.7914 17.4199 17.593 17.4199 18.5818C17.4199 19.5706 18.0326 20.3722 18.7884 20.3722Z" fill="white"></path>
<path d="M13.6902 24.0985V28.7126C13.6902 28.861 13.63 28.995 13.5327 29.0925C13.4352 29.1898 13.301 29.25 13.1526 29.25C12.8563 29.25 12.6152 29.0089 12.6152 28.7126V24.0985H13.1526H13.6902ZM19.3208 24.136V28.718C19.3208 28.8646 19.2612 28.9975 19.1649 29.0939C19.0685 29.1902 18.9354 29.25 18.7888 29.25C18.4955 29.25 18.2569 29.0114 18.2569 28.7181V24.1362H18.7888H19.3208V24.136Z" fill="white"></path>
<path d="M26.0701 11.9165V34.125H5.85449V11.9165H26.0701ZM20.8002 18.5817C20.8002 17.9449 20.5995 17.3434 20.2348 16.8879C19.8534 16.4112 19.3398 16.1486 18.7889 16.1486C18.2379 16.1486 17.7244 16.4112 17.3431 16.8879C16.9784 17.3436 16.7775 17.9449 16.7775 18.5817C16.7775 19.2185 16.9784 19.8203 17.3431 20.2758C17.6491 20.6584 18.0403 20.9027 18.4676 20.9844V23.4931H17.9357C17.7583 23.4931 17.6143 23.6371 17.6143 23.8145V28.7179C17.6143 29.3658 18.1414 29.8927 18.789 29.8927C19.4369 29.8927 19.9638 29.3658 19.9638 28.7179V23.8145C19.9638 23.6371 19.82 23.4931 19.6424 23.4931H19.1105V20.9844C19.5378 20.9029 19.929 20.6584 20.2352 20.2758C20.5995 19.8203 20.8002 19.2185 20.8002 18.5817ZM15.1808 19.4882V16.4699C15.1808 16.2924 15.037 16.1484 14.8593 16.1484C14.6819 16.1484 14.5379 16.2924 14.5379 16.4699V19.488C14.5379 19.9753 14.1414 20.372 13.6539 20.372H13.474V16.4699C13.474 16.2924 13.3302 16.1484 13.1525 16.1484C12.975 16.1484 12.8311 16.2924 12.8311 16.4699V20.372H12.6511C12.1638 20.372 11.7671 19.9755 11.7671 19.488V16.4699C11.7671 16.2924 11.6234 16.1484 11.4457 16.1484C11.2682 16.1484 11.1243 16.2924 11.1243 16.4699V19.488C11.1243 20.3299 11.8092 21.0149 12.6511 21.0149H12.8311V23.4556H12.2937C12.116 23.4556 11.9722 23.5996 11.9722 23.777V28.7126C11.9722 29.3633 12.5016 29.8929 13.1525 29.8929C13.8034 29.8929 14.333 29.3633 14.333 28.7126V23.777C14.333 23.5996 14.1892 23.4556 14.0115 23.4556H13.474V21.0149H13.6539C14.4958 21.0149 15.1808 20.3301 15.1808 19.4882Z" fill="white"></path>
</svg></div>
        </div>

        <div className="macrorow">
          
            {this.renderMacroRow(
              'Kcal',
              this.renderRange('kcal',data,combine) + ' Kcal',
              'kcal-icon'
            )}
            <div class="macrodetails">
                {this.renderMacroRow(
                'Protein',
                this.renderRange('protein',data,combine) + 'g',
                'protein-icon'
                )}
                {this.renderMacroRow(
                'Carbohydrate',
                this.renderRange('cho',data,combine) + 'g',
                'carb-icon'
                )}
            </div>
            {this.renderMacroRow(
              'Fat',
              this.renderRange('fat',data,combine) + 'g',
              'fat-icon'
            )}
        </div>
      </article>
    );
  };

  render() {
    const { value,title, plan,handle,clearModal} = this.props;
    const items = plan.samplemenu || [];
   
    return (
      <div className="weight-loss-wrapper">
        <div
          className="sample-menu-modal"
          role="dialog"
          aria-modal="true"
        >

          {/* Header */}
          <div className="plan-header">
            <div className="plan-price">
              <span>Starting at </span>
              <strong>AED {plan.startprice}</strong>
              <span>/day</span>
            </div>
            <div className='action_btns'>
                <button className="btn continue-btn avenir-medium font-15" onClick={()=>{this.props.setDietType(value,handle);clearModal();}}>Continue</button> 
            </div>
          </div>

          {/* Description */}
          {/* <div className="plan-description">
            <p>{plan.description}</p>
          </div> */}

          {/* Information sections */}
          <section className="info-sections">
            {this.renderInfoSection(
              `What is this ${title} Plan?`,
               plan.benfit
            )}

            {this.renderInfoSection(
              `How will ${title} Plan help?`,
              plan.useage
            )}
          </section>

          {/* Macro section */}
          <section className="sample-macros-container">
            <h3>
              Sample Macros for your {title} Meal Plan
            </h3>

            <div className="macros-container">

              {/* Breakfast */}
              {this.renderMacroCard(
                'Lunch & Dinner',
                plan,
                ['main','main']
              )}

              {/* Main meal */}
              {this.renderMacroCard(
                'Breakfast, Lunch & Dinner',
                plan,
                ['breakfast','main','main']
              )}

              {/* Snack */}
              {this.renderMacroCard(
                'Breakfast, 2 Snacks, Lunch & Dinner',
                plan,
              ['breakfast','main','main','snack','snack']
              )}
            </div>
          </section>
          {this.renderSampleMenu(items)}
        </div>
      </div>
    );
  }
}

export default SampleMenu;